import React, { useState } from "react";
import Navbarside from "../component/Navbarside";
import Moment from "moment";
import Footer from "./footer";

import { ExportToExcel } from "./ExportToExcel";
import { API_PATHS } from "../utils/constants/api.constants";
import axios from "axios";
import $ from "jquery";

const FitnessGeneralEnquiry = () => {
  const [data, setData] = useState([]);
  const fileName = "fitnessEnquiry";

  React.useEffect(() => {
    const fetchData = () => {
      axios.get(API_PATHS.getEnquiry + "?category=Fitness").then((postData) => {
        const customHeadings = postData.data.data.map((item) => ({
          Name: item.name,
          Email: item.email,
          "Mobile No.": item.contactNumber,
          Profession: item.profession,
          "Health Conditions": item.healthConditions,
        }));

        setData(customHeadings);
        $("#example").DataTable({
          data: postData.data.data.map((e, index) => {
            return { index, ...e };
          }),
          columns: [
            {
              title: "#",
              render: (data, type, row) => {
                return ++row.index;
              },
            },
            {
              title: "User Details",
              render: (data, type, row) => {
                return `Name: ${row.name}<br> Email: ${row.email}<br>Mobile Number: ${row.contactNumber}`;
              },
            },
            {
              data: "message",
              title: "Message",
            },
            {
              data: "category",
              title: "Category",
            },
            {
              title: "Date of Enquiry",
              render: (data, type, row) => {
                return `${Moment(row.created_at).format("DD-MM-YYYY")}/${Moment(
                  row.created_at
                ).format("hh:mm A")}`;
              },
            },
            {
              data: "status",
              title: "Status",
            },
            {
              title: "Action",
              render: (data, type, row) => {
                const updateStatusBtn = `<div><a href="/UpdateEnquiry/${row._id ? row._id : null
                  }" class="btn btn-primary" style="height: 25px; padding: 0 10px">Update Status</a></div>`;
                const assignExpertBtn = `<div><a
                href="/ProcessEnquiry/'${row._id ? row._id : null
                  }?userId=${row.userId ? row.userId : 'guest'}&ticketNumber=${row.ticketNumber}"
                class="btn btn-warning"
                style="height: 25px; padding: 0 10px"
              >
                Assign Expert
              </a></div>`;
                return row.status === "Interested" ? updateStatusBtn + assignExpertBtn : updateStatusBtn;

              },
            },
          ],
          destroy: true,
        });
      });
    };
    fetchData();
  }, []);

  return (
    <div>
      <Navbarside />

      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title-wrap bar-success d-flex align-items-center">
                        <h4 className="card-title">General Fitness Enquiry</h4>{" "}
                        &nbsp; &nbsp; &nbsp;
                        <ExportToExcel apiData={data} fileName={fileName} />
                      </div>
                    </div>
                    <div className="card-body collapse show">
                      <div className="card-block card-dashboard table-responsive">
                        <table id="example" className="display"></table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FitnessGeneralEnquiry;